import React, { useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthorize, selectLoading } from "stores/reducers/userReducer";
import { Capacitor } from "@capacitor/core";

const PrivateRoute = ({ children, ...rest }) => {
  const history = useHistory();
  const authorize = useSelector(selectAuthorize);
  const loading = useSelector(selectLoading);
  const getPlatform = Capacitor.getPlatform();

  useEffect(() => {
    const onMount = async () => {
      if (
        !authorize &&
        (process.env.REACT_APP_MODE === "local" ||
          process.env.REACT_APP_MODE === "dev")
      )
        return history.push("/login");
      if (!authorize && getPlatform === "web")
        window.location = "https://ekrutes.id";
      if (!authorize && getPlatform !== "web") history.push("/onBoard");
    };
    if (!loading) onMount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorize, loading]);

  return <Route {...rest}>{children}</Route>;
};

export default PrivateRoute;
